<template>
  <v-container fluid class="pa-4">
    <!-- بنر -->
    <v-banner
      v-if="showbanner"
      single-line
      color="amber lighten-5"
      class="mb-4 rounded-lg"
      elevation="2"
    >
      <v-icon slot="icon" color="amber darken-2"
        >mdi-information-outline</v-icon
      >
      <span class="font-weight-medium">
        {{ $t("language.only_manual_now") }}
      </span>
      <br />
      <span class="text-caption grey--text text--darken-1">
        {{ $t("language.ai_coming_soon") }}
      </span>

      <template v-slot:actions>
        <v-btn text small color="primary" @click="showbanner = false">
          {{ $t("language.got_it") }}
        </v-btn>
      </template>
    </v-banner>

    <!-- دکمه حذف همه -->
    <v-btn
      icon
      color="error"
      @click="clearAll"
      v-if="selectedLanguages?.length"
      class="mb-3"
      :title="$t('language.remove_all')"
    >
      <v-icon>mdi-delete-sweep</v-icon>
    </v-btn>
    <v-col col="12" class="text-center">
      <span>
        {{ $t("language.origin_language") }}:
        {{ $t(`language.lang.${value.source_lang}`) }}
      </span>
    </v-col>
    <!-- سلکت زبان‌های هدف -->
    <v-select
      v-model="selectedLanguages"
      :items="targetLanguages"
      :label="$t('language.target_languages')"
      multiple
      chips
      outlined
      deletable-chips
      return-object
      class="mt-3"
      @change="syncToLangs"
    >
      <!-- چیپ -->
      <template v-slot:selection="{ item }">
        <v-chip
          :color="getChipColor(item)"
          :text-color="getTextColor(item)"
          close
          @click:close="removeByLang(item.lang)"
          @click.stop="openAction(item)"
          class="ma-1"
          small
        >
          <v-icon left small>{{ getIcon(item) }}</v-icon>
          <img :src="item.flag" alt="" width="20" class="mr-2 rounded" />
          {{ $t(`language.lang.${item.lang}`) }}
        </v-chip>
      </template>

      <!-- آیتم لیست -->
      <template v-slot:item="{ item, attrs, on }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-action>
            <v-checkbox :input-value="isSelected(item)"></v-checkbox>
          </v-list-item-action>
          <img :src="item.flag" alt="" width="20" class="mr-2 rounded" />
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle class="text--secondary">
              {{ $t(`language.lang.${item.lang}`) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <!-- انتخاب همه -->
      <template v-slot:prepend-item>
        <v-list-item @click="toggleAll">
          <v-list-item-action>
            <v-checkbox :input-value="allSelected"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
              $t("language.selectAll")
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>
    </v-select>

    <!-- دیالوگ -->
    <custom-popup
      v-model="dialog"
      :cons="{ title: $t('language.translation_method') }"
      hide-confirm
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">{{ current?.name }}</v-card-title>
        <v-card-text class="body-1">
          {{ $t("language.translation_method") }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <!-- دستی -->
          <v-btn text color="blue" @click="setStatus('edited')">
            <v-icon left>mdi-account-edit</v-icon>
            {{ $t("language.manual_translation") }}
          </v-btn>

          <!-- AI -->
          <v-badge
            :content="$t('coming_soon')"
            color="warning"
            offset-x="20"
            offset-y="10"
            left
            overlap
            class="ml-2"
          >
            <template v-slot:badge>
              <span class="text-caption font-weight-bold white--text">
                {{ $t("coming_soon") }}
              </span>
            </template>

            <v-btn
              text
              color="purple"
              @click="setStatus('ai_translated')"
              :disabled="true"
            >
              <v-icon left>mdi-robot</v-icon>
              {{ $t("language.ai_translation") }}
            </v-btn>
          </v-badge>
        </v-card-actions>
      </v-card>
    </custom-popup>
  </v-container>
</template>

<script>
export default {
  name: "addLanguage",

  props: {
    value: { type: Object, required: true },
  },

  data() {
    return {
      showbanner: true,
      selectedLanguages: [],
      dialog: false,
      current: null,
      allLanguages: [
        {
          lang: "en_US",
          name: "English (US)",
          flag: "/media/flag/us.svg",
        },
        {
          lang: "en_GB",
          name: "English (UK)",
          flag: "/media/flag/gb.svg",
        },
        {
          lang: "fa",
          name: "فارسی",
          flag: "/media/flag/ir.svg",
        },
        {
          lang: "ar",
          name: "العربية",
          flag: "/media/flag/sa.svg",
        },
        {
          lang: "ar_ae",
          name: "العربية (الإمارات)",
          flag: "/media/flag/ae.svg",
        },
        {
          lang: "ar_iq",
          name: "العربية (العراق)",
          flag: "/media/flag/iq.svg",
        },
        {
          lang: "de",
          name: "Deutsch",
          flag: "/media/flag/de.svg",
        },
        {
          lang: "fr",
          name: "Français",
          flag: "/media/flag/fr.svg",
        },
        {
          lang: "hy",
          name: "Հայերեն",
          flag: "/media/flag/am.svg",
        },
        {
          lang: "ru",
          name: "Русский",
          flag: "/media/flag/ru.svg",
        },
        {
          lang: "tr",
          name: "Türkçe",
          flag: "/media/flag/tr.svg",
        },
        {
          lang: "zh_CN",
          name: "简体中文",
          flag: "/media/flag/cn.svg",
        },
        {
          lang: "zh_TW",
          name: "繁體中文",
          flag: "/media/flag/tw.svg",
        },
      ],
    };
  },

  computed: {
    sourceLanguage() {
      return this.value?.source_lang || "fa";
    },
    targetLanguages() {
      return this.allLanguages.filter((l) => l.lang !== this.sourceLanguage);
    },
    allSelected() {
      const targetCount = this.targetLanguages?.length;
      const selectedCount = this.selectedLanguages?.length;
      return targetCount > 0 && selectedCount === targetCount;
    },
  },

  methods: {
    isSelected(item) {
      return this.selectedLanguages.some((l) => l.lang === item.lang);
    },
    getChipColor(item) {
      const map = {
        edited: "blue lighten-4",
        ai_translated: "purple lighten-4",
      };
      return map[item.status] || "grey";
    },
    getTextColor(item) {
      return ["blue"].includes(this.getChipColor(item)) ? "white" : "black";
    },
    getIcon(item) {
      const map = {
        edited: "mdi-account-edit",
        ai_translated: "mdi-robot",
      };
      return map[item.status] || "mdi-help-circle";
    },
    removeByLang(lang) {
      this.selectedLanguages = this.selectedLanguages?.filter(
        (l) => l.lang !== lang
      );
      this.syncToLangs();
    },
    clearAll() {
      this.selectedLanguages = [];
      this.syncToLangs();
    },
    toggleAll() {
      if (this.allSelected) {
        this.selectedLanguages = [];
      } else {
        this.selectedLanguages = this.targetLanguages?.map((lang) => {
          const existing = this.selectedLanguages?.find(
            (s) => s.lang === lang.lang
          );
          const status = existing?.status || "edited";
          this.$set(lang, "status", status);
          return lang;
        });
      }
      this.syncToLangs();
    },
    openAction(item) {
      this.current = item;
      this.dialog = false;
    },
    setStatus(status) {
      const lang = this.selectedLanguages?.find(
        (l) => l.lang === this.current.lang
      );
      if (lang) this.$set(lang, "status", status);
      this.dialog = false;
      this.syncToLangs();
    },

    syncToLangs() {
      const updated = {
        source_lang: this.sourceLanguage,
        other_langs: this.selectedLanguages?.map((l) => ({
          lang: l.lang,
          status: l.status || "edited",
        })),
      };
      this.$emit("input", updated);
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    value: {
      handler(newVal) {
        if (newVal?.source_lang && Array.isArray(newVal.other_langs)) {
          const selected = newVal.other_langs
            .map((ol) => {
              const baseLang = this.targetLanguages.find(
                (l) => l.lang === ol.lang
              );
              if (baseLang) {
                this.$set(baseLang, "status", ol.status || "edited");
                return baseLang;
              }
              return null;
            })
            .filter(Boolean);

          this.selectedLanguages = selected;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.syncToLangs();
  },
};
</script>

<style scoped>
.rounded {
  border-radius: 4px;
}
</style>
